export default __webpack_public_path__ + "static/media/video3.fb2685b4.webp";